module.exports = __webpack_public_path__ + "static/media/018admin_5 credit check - new @2x.19ba253d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/018admin_5 credit check - new @2x.png
// module id = 582
// module chunks = 0